export default "__VITE_ASSET__bc10ceff__"